var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"expressOverlay"},[_c('v-icon',{staticClass:"expressOverlay__icon"},[_vm._v("mdi-flash")]),_c('div',{staticClass:"expressOverlay__text"},[_vm._v("EXPRESS")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }